import React from "react";
import { RankingProducaoViewProps } from "../types";
import { Header } from "./Header";
import { NavigationButtons } from "./NavigationButtons";
import { LojaSelector } from "./LojaSelector";
import { RankingList } from "./RankingList";
import { StatsCard } from "./StatsCard";

export const RankingProducaoView: React.FC<RankingProducaoViewProps> = ({
  pizzaiolos = [],
  dailyStats = {
    pizzasFinalizadas: 0,
    tempoMedioGeral: 0,
    pizzaiolos: 0,
    emProducao: 0,
  },
  lojas = [],
  selectedLojaId,
  showLojaSelector = false,
  dateLabel,
  selectedLojaNome,
  onGoHome,
  onToggleLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden bg-red-900 text-white">
      <NavigationButtons
        lojasCount={lojas.length}
        onGoHome={onGoHome}
        onToggleLojaSelector={onToggleLojaSelector}
      />

      <LojaSelector
        lojas={lojas}
        selectedLojaId={selectedLojaId}
        showLojaSelector={showLojaSelector}
        onSelectAllLojas={onSelectAllLojas}
        onSelectLoja={onSelectLoja}
      />

      <Header
        dateLabel={dateLabel}
        selectedLojaId={selectedLojaId}
        selectedLojaNome={selectedLojaNome}
      />

      <div className="min-h-0 flex-1 overflow-y-auto px-3 pb-4 pt-1 sm:px-6">
        <div className="mx-auto flex min-h-full max-w-6xl flex-col">
          <RankingList pizzaiolos={pizzaiolos} />
          <StatsCard dailyStats={dailyStats} />
        </div>
      </div>
    </div>
  );
};
